export default "__VITE_ASSET__CT5mbW99__"